import { defineMessages } from "react-intl";

const EXECUTION_SUCCESS = "execution-success";

const executionSuccessMessages = defineMessages({
  thankYou: {
    id: `${EXECUTION_SUCCESS}.thank-you`,
    defaultMessage: "Thank you"
  },
  emailSent: {
    id: `${EXECUTION_SUCCESS}.email-sent`,
    defaultMessage:
      "You'll receive an email when your accounts merge is completed."
  }
});

export default executionSuccessMessages;
